<template>
  <div>

    <div
      class="variants"
      :class="useDropdown?'use-dropdown':'no-dropdown'"
    >
      <a
        :href="currentVariant.link"
        @click.prevent="toggleDropdown"
        class="opener active"
        v-if="useDropdown"
      >
        <span class="swatch">
          <i
            class="swatch"
            :style="{backgroundColor:color}"
            v-for="color in currentVariant.colors" :key="color"
          ></i>
        </span>


        <span class="text" v-if="currentVariant">{{currentVariant.name}}</span>
        <span class="marker">
          <i
            v-if="dropdownOpen"
            class='fal fa-chevron-up'
          ></i>
          <i
            v-else
            class='fal fa-chevron-down'
          ></i>
        </span>
      </a>
      <div
        class="listedVariants"
        v-if="dropdownVisible"
      >
        <div
          v-for="(v, index) in listedVariants"
          :key="index"
          :href="v.link"
          class="variant"
          :class="[(v.id==$store.getters.currentVariantId)?'active':'not-active']"
        >

        <span class="swatch-img" v-if="v.swatch!=''" 
                  @click.prevent="setCurrentVariantId(v.id)"
>
          <img :src="v.swatch" v-if=" v.swatch!='' " />
        </span>

        <span class="swatch"  @click.prevent="setCurrentVariantId(v.id)"
 v-else >
          <i
            class="swatch"
            :style="{backgroundColor:color}"
            v-for="color in v.colors" :key="color"
          ></i>
        </span>


         

          <span class="text">{{v.name}}

              <div v-if="colorlink(v.slug)"><a :href="colorlink(v.slug)">❯ more info</a></div>


          </span>

          <span v-if="v.addonhtml"  v-html="v.addonhtml" />

          <template v-if="!(v.inStock>0) ">
            <span
              v-if="v.ondemand"
              class="col3 ondemand-marker"
              :title="trans('made-to-order-Delivery-Time','made-to-order - Lieferzeit')" >{{ v.ondemand}}</span>
            <span
              v-else
              class="col3 soldout-marker"
            >sold out</span>
          </template>

          <span
            v-if="v.inStock>0 && v.pricetype=='sale'"
            class="col3 sale-marker"
          >%</span>
          <span class="marker">
            <i class='fal fa-check'></i>
          </span>
        </div>
      </div>
    </div>
    <div>&nbsp;</div>
    <div class="addtocart">
      <div v-if="currentVariant.inStock>0 || currentVariant.ondemand">
        <button
          class="btn btn-outline-primary btn-intocart"
          @click="addToCart($store.getters.currentVariantId)"
        >Add to Cart</button>
      </div>
      <div v-else>
        <span class="btn btn-outline btn-intocart">Sold Out</span>
      </div>
    </div>
  </div>
</template>

<script>
const R = require("ramda");

var splitPlus = function (str, sep) {
  var a = str.split(sep);
  if (a[0] == "" && a.length == 1) return [];
  return a;
};
export default {
  name: "Variants",
  data() {
    return {
      dropdownOpen: false,
    };
  },
  props: {
    childNodes: { type: Array },
    currentVariantId: { type: String },
  },
  components: {},
  methods: {
    trans: function (en, de) {
      return this.$store.getters.lang == "de" ? de : en;
    },
    setCurrentVariantId: function (id) {
      this.$store.commit("setCurrentVariantId", id);
      this.dropdownOpen = false;
    },
    toggleDropdown: function () {
      console.log("#log 5226", this.dropdownOpen);
      this.dropdownOpen = !this.dropdownOpen;
    },
    addToCart: function (sku) {
      let sku2store=sku
      if (this.currentVariant.pricetype=='voucher') {
         sku2store=this.checkVoucher(sku);
      } 

      if(sku2store) {
        this.$store.dispatch("addToCart", sku2store);
      }
      

    },
    checkVoucher: function (sku) {
      const customPrice=this.$store.getters.customPrice;
      if(customPrice<50 ) {
        alert("soyy, but the minimum Voucher-Value is 50EUR");
        return null;
      } else {
        return `${sku}-${customPrice}`;
      }
    },
    colorlink: function(slug) {
      if (slug && slug.startsWith("shades-of-")) {
        return "../"+slug;
      }
    },
  },
  computed: {
    dropdownVisible: function (re) {
      if (this.useDropdown) {
        return this.dropdownOpen;
      }
      return true;
    },
    useDropdown: function () {
      return false;
      // return R.length(this.variants || []) > 10;
    },
    variants: function () {
      return R.map((item) => {
        console.log('#log 6861 ',item);
        return {
          name: item.name,
          swatch: item.swatch,
          link: item.href,
          id: parseInt(item.dbid, 10),
          inStock: parseInt(item.instock, 10),
          pricestr: item.pricestr,
          slug: item.slug,
          pricetype: item.pricetype,
          ondemand: item.ondemand,
          addonhtml: item.addonhtml,
          colors: item.colorstr.split(',').reverse(),
          imgIds: R.map((a) => parseInt(a, 10))(splitPlus(item.imgs, ",")),
        };
      })(this.childNodes);
    },
    listedVariants: function () {
      if (this.useDropdown) {
        const currentVariantId = this.$store.getters.currentVariantId;
        return R.filter((a) => a.id !== currentVariantId)(this.variants);
      }
      return this.variants;
    },
    currentVariant: function () {
      return this.$store.getters.currentVariant;
    },
    langPrefix: function() {
      return this.$store.getters.lang=="de"?"de/":"";
      
    }

  },
  created: function () {
    this.$store.commit("setVariants", [...this.variants]);
    this.$store.commit(
      "setCurrentVariantId",
      parseInt(this.currentVariantId, 10)
    );
  },
};
</script>
<style lang="scss">
@import "../styles/settings.scss";
</style>
